import { useDispatch, useSelector } from "react-redux";
import dislikedImage from "../../assets/disliked.png";
import likeImage from "../../assets/like.png";
import likedImage from "../../assets/liked.png";
import unlikeImage from "../../assets/unlike.svg";
import { toggleDisLike, toggleLike } from "../../features/video/videoSlice";

export default function LikeUnlike() {
    const { video: { id, likes, unlikes }, liked, unLiked } = useSelector(state => state.video);
    const dispatch = useDispatch();

    return (
        <div className="flex gap-10 w-48">
            <div onClick={() => { dispatch(toggleLike(id)) }} className="flex gap-1 cursor-pointer">
                <div className="shrink-0">
                    <img className="w-5 block" src={liked ? likedImage : likeImage} alt="Like" />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {likes}
                </div>
            </div>
            <div onClick={() => { dispatch(toggleDisLike(id)) }} className="flex gap-1 cursor-pointer">
                <div className="shrink-0">
                    <img className="w-5 block" src={unLiked ? dislikedImage : unlikeImage} alt="Unlike" />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {unlikes}
                </div>
            </div>
        </div>
    );
}
